<template>
  <div class="q7" :class="{ fade: fade }">
    <div class="content">
      <AppBar></AppBar>
      <img
        class="q-index"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-head"
      />
      <div class="q-title animate__animated animate__fadeInDown">
        <img
          class="title-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-title"
          alt=""
        />
      </div>
      <div class="q-box">
        <img
          class="q-image image1 animate__animated animate__zoomIn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-a"
          alt=""
        />
        <img
          class="q-image image2 animate__animated animate__zoomIn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-b"
          alt=""
        />
        <img
          class="q-image image3 animate__animated animate__zoomIn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-c"
          alt=""
        />
        <img
          class="q-image image4 animate__animated animate__zoomIn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-d"
          alt=""
        />
        <img
          class="q-image image5 animate__animated animate__zoomIn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-e"
          alt=""
        />
        <img
          class="q-image image6 animate__animated animate__zoomIn"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-f"
          alt=""
        />
        <QBtn
          v-for="(item, index1) in data[index].field_unit"
          :key="index1"
          class="q-btn animate__animated"
          :class="[
            'btn-' + index1,
            confirm && !active.includes(index1) ? 'animate__fadeOut' : '',
            !isChecked && !active.length ? 'animate__bounceIn' : ''
          ]"
          :style="{
            animationDelay: active.length ? '0s' : 0.5 + index1 * 0.2 + 's'
          }"
          :type="checkType"
          :sort="item.key"
          :index="index1"
          :active="active"
          :disabled="confirm"
          @change="bindChange"
          >{{ item.value }}</QBtn
        >
      </div>
      <div class="q-next" @click.stop="bindNext" v-if="active.length"
        >选好了</div
      >
    </div>
  </div>
</template>
<script>
import QBtn from './q-btn.vue'
import AppBar from '../app-bar.vue'
export default {
  components: {
    QBtn,
    AppBar
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkType: 1, //选择类型
      fade: false,
      isChecked: false,
      confirm: false, //是否选择完成
      active: []
    }
  },
  mounted() {
    this.$buryPoint('BG_XRWJ_WT7', {})
  },
  methods: {
    //获取选项结果
    getRes() {
      let res = []
      this.active.map((item) => {
        res.push(this.data[this.index].field_unit[item].key)
      })
      return res
    },
    //计算分数
    getScore(options, values) {
      let score = 0
      for (let i = 0; i < options.length; i++) {
        if (values.includes(options[i].key)) {
          score += options[i].score
          if (options[i].score == 0) {
            score = 0
            break
          }
        }
      }
      return score
    },
    bindNext() {
      if (this.confirm) {
        return
      }
      this.confirm = true
      this.data[this.index].value = this.getRes()
      this.data[this.index].data_num = this.getScore(
        this.data[this.index].field_unit,
        this.data[this.index].value
      )
      setTimeout(() => {
        this.fade = true
        setTimeout(() => {
          this.$emit('next', this.active)
        }, 500)
      }, 500)
    },
    bindChange(index, checked) {
      this.isChecked = true
      let arrIndex = this.active.indexOf(index)
      if (arrIndex >= 0) {
        if (!checked) {
          this.active.splice(arrIndex, 1)
        }
      } else {
        this.active.push(index)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.fade {
  opacity: 0;
}
.q7 {
  opacity: 1;
  transition: opacity 0.5s ease-in;
  position: relative;
  overflow-y: scroll;
  width: 100%;
  min-height: 100vh;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-q7-bg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .content {
  }
  .pre-btn {
    position: absolute;
    left: 10px;
    top: 20px;
  }
  .q-index {
    width: 328px;
    object-fit: contain;
    margin: 7px auto 13px;
    height: 61px;
  }
  .q-title {
    width: 100%;
    margin-bottom: 5px;
    .title-image {
      margin: 0 auto 0 12px;
      width: 316px;
      height: 121px;
    }
  }
  .q-box {
    height: 407px;
    position: relative;
    margin-bottom: 20px;
    .q-image {
      object-fit: contain;
    }
    .image1 {
      position: absolute;
      width: 144px;
      height: 145px;
      left: 71px;
      top: 0;
    }
    .image2 {
      position: absolute;
      width: 136px;
      height: 187px;
      top: 6px;
      left: 187px;
    }
    .image3 {
      position: absolute;
      width: 128px;
      height: 118px;
      top: 148px;
      left: 39px;
    }
    .image4 {
      position: absolute;
      width: 133px;
      height: 79px;
      top: 172px;
      left: 187px;
    }
    .image5 {
      position: absolute;
      width: 115px;
      height: 93px;
      top: 258px;
      left: 214px;
    }
    .image6 {
      position: absolute;
      width: 162px;
      height: 134px;
      top: 273px;
      left: 50px;
    }
    .q-btn {
      position: absolute;
    }
    .btn-0 {
      top: 66px;
      left: 38px;
    }
    .btn-1 {
      top: 29px;
      left: 232px;
    }
    .btn-2 {
      top: 222px;
      left: 78px;
    }
    .btn-3 {
      top: 160px;
      left: 249px;
    }
    .btn-4 {
      top: 313px;
      left: 224px;
    }
    .btn-5 {
      top: 350px;
      left: 78px;
    }
  }
  .q-next {
    margin: 0 auto 57px;
    text-align: center;
    line-height: 40px;
    width: 274px;
    height: 42px;
    box-sizing: border-box;
    border-radius: 22px;
    border: 2px solid rgba(0, 0, 0, 0.9);
  }
}
.fade {
  opacity: 0;
}
</style>
